import { render, staticRenderFns } from "./ModalDefault.vue?vue&type=template&id=fddc41b2&scoped=true&"
import script from "./ModalDefault.vue?vue&type=script&lang=js&"
export * from "./ModalDefault.vue?vue&type=script&lang=js&"
import style0 from "./ModalDefault.vue?vue&type=style&index=0&id=fddc41b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddc41b2",
  null
  
)

export default component.exports